export enum ScreenStyleConfigKeys {
  OneOptionWithFeedbacks = 'OneOptionWithFeedbacks',
  SeveralOptionsWithFeatures = 'SeveralOptionsWithFeatures',
  ThreeOptionsWithFeedbacks = 'ThreeOptionsWithFeedbacks',
}
